var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6377 40.3977C37.5272 40.3977 37.4377 40.4873 37.4377 40.5977C37.4377 40.7082 37.5272 40.7977 37.6377 40.7977V40.3977ZM37.0025 16.2652C37.1129 16.2595 37.1976 16.1655 37.1919 16.0552C37.1862 15.9449 37.0922 15.8601 36.9818 15.8658L37.0025 16.2652ZM37.419 15.8507C37.3085 15.8526 37.2205 15.9437 37.2224 16.0541C37.2243 16.1646 37.3154 16.2525 37.4259 16.2506L37.419 15.8507ZM38.5862 16.2855C38.6963 16.2941 38.7925 16.2117 38.801 16.1016C38.8096 15.9915 38.7273 15.8953 38.6171 15.8867L38.5862 16.2855ZM40.5508 16.1909C40.4434 16.1652 40.3355 16.2314 40.3098 16.3388C40.2841 16.4463 40.3503 16.5542 40.4578 16.5799L40.5508 16.1909ZM42.2596 17.165C42.3616 17.2073 42.4786 17.1589 42.5209 17.0568C42.5632 16.9548 42.5148 16.8378 42.4128 16.7955L42.2596 17.165ZM44.1564 17.6856C44.0623 17.6278 43.9392 17.6572 43.8814 17.7513C43.8236 17.8455 43.853 17.9686 43.9471 18.0264L44.1564 17.6856ZM45.4794 19.1415C45.5634 19.2133 45.6896 19.2034 45.7614 19.1194C45.8332 19.0355 45.8233 18.9092 45.7393 18.8375L45.4794 19.1415ZM47.1235 20.2216C47.0517 20.1377 46.9254 20.1278 46.8415 20.1995C46.7575 20.2713 46.7476 20.3976 46.8194 20.4815L47.1235 20.2216ZM47.9345 22.0138C47.9923 22.1079 48.1155 22.1374 48.2096 22.0796C48.3037 22.0218 48.3332 21.8986 48.2754 21.8045L47.9345 22.0138ZM49.1655 23.5482C49.1231 23.4461 49.0061 23.3977 48.9041 23.44C48.8021 23.4823 48.7537 23.5993 48.796 23.7014L49.1655 23.5482ZM49.381 25.5032C49.4067 25.6106 49.5147 25.6768 49.6221 25.6511C49.7295 25.6254 49.7958 25.5175 49.7701 25.4101L49.381 25.5032ZM50.0742 27.3438C50.0656 27.2337 49.9694 27.1513 49.8593 27.1599C49.7492 27.1684 49.6668 27.2646 49.6754 27.3748L50.0742 27.3438ZM49.6754 29.2718C49.6668 29.3819 49.7492 29.4781 49.8593 29.4867C49.9694 29.4952 50.0656 29.4129 50.0742 29.3028L49.6754 29.2718ZM49.7701 31.2365C49.7958 31.129 49.7295 31.0211 49.6221 30.9954C49.5147 30.9697 49.4067 31.036 49.381 31.1434L49.7701 31.2365ZM48.796 32.9452C48.7537 33.0472 48.8021 33.1642 48.9041 33.2065C49.0061 33.2488 49.1231 33.2004 49.1655 33.0984L48.796 32.9452ZM48.2754 34.8421C48.3332 34.7479 48.3037 34.6248 48.2096 34.567C48.1155 34.5092 47.9923 34.5386 47.9345 34.6327L48.2754 34.8421ZM46.8194 36.165C46.7476 36.249 46.7575 36.3752 46.8415 36.447C46.9254 36.5188 47.0517 36.5089 47.1235 36.4249L46.8194 36.165ZM45.7393 37.8091C45.8233 37.7373 45.8332 37.6111 45.7614 37.5271C45.6896 37.4431 45.5634 37.4333 45.4794 37.505L45.7393 37.8091ZM43.9471 38.6201C43.853 38.6779 43.8236 38.8011 43.8814 38.8952C43.9392 38.9893 44.0623 39.0188 44.1564 38.961L43.9471 38.6201ZM42.4128 39.8511C42.5148 39.8088 42.5632 39.6918 42.5209 39.5897C42.4786 39.4877 42.3616 39.4393 42.2596 39.4816L42.4128 39.8511ZM40.4578 40.0667C40.3503 40.0924 40.2841 40.2003 40.3098 40.3077C40.3355 40.4151 40.4434 40.4814 40.5508 40.4557L40.4578 40.0667ZM38.6171 40.7598C38.7273 40.7513 38.8096 40.6551 38.801 40.5449C38.7925 40.4348 38.6963 40.3525 38.5862 40.361L38.6171 40.7598ZM36.7912 16.278C36.8615 16.2732 36.9319 16.2689 37.0025 16.2652L36.9818 15.8658C36.9089 15.8696 36.8361 15.874 36.7635 15.879L36.7912 16.278ZM37.4259 16.2506C37.4963 16.2494 37.5669 16.2488 37.6377 16.2488V15.8488C37.5646 15.8488 37.4917 15.8495 37.419 15.8507L37.4259 16.2506ZM37.6377 16.2488C37.9569 16.2488 38.2732 16.2612 38.5862 16.2855L38.6171 15.8867C38.2939 15.8616 37.9673 15.8488 37.6377 15.8488V16.2488ZM40.4578 16.5799C41.0784 16.7284 41.6803 16.9248 42.2596 17.165L42.4128 16.7955C41.8142 16.5473 41.1922 16.3443 40.5508 16.1909L40.4578 16.5799ZM43.9471 18.0264C44.4874 18.3582 44.9997 18.7314 45.4794 19.1415L45.7393 18.8375C45.2438 18.4138 44.7147 18.0284 44.1564 17.6856L43.9471 18.0264ZM46.8194 20.4815C47.2295 20.9613 47.6027 21.4735 47.9345 22.0138L48.2754 21.8045C47.9326 21.2463 47.5471 20.7171 47.1235 20.2216L46.8194 20.4815ZM48.796 23.7014C49.0362 24.2806 49.2326 24.8826 49.381 25.5032L49.7701 25.4101C49.6166 24.7688 49.4137 24.1467 49.1655 23.5482L48.796 23.7014ZM49.6754 27.3748C49.6997 27.6877 49.7121 28.004 49.7121 28.3233H50.1121C50.1121 27.9937 50.0993 27.667 50.0742 27.3438L49.6754 27.3748ZM49.7121 28.3233C49.7121 28.6425 49.6997 28.9588 49.6754 29.2718L50.0742 29.3028C50.0993 28.9795 50.1121 28.6529 50.1121 28.3233H49.7121ZM49.381 31.1434C49.2326 31.764 49.0362 32.3659 48.796 32.9452L49.1655 33.0984C49.4137 32.4998 49.6166 31.8778 49.7701 31.2365L49.381 31.1434ZM47.9345 34.6327C47.6027 35.1731 47.2295 35.6853 46.8194 36.165L47.1235 36.4249C47.5471 35.9294 47.9326 35.4003 48.2754 34.8421L47.9345 34.6327ZM45.4794 37.505C44.9997 37.9152 44.4874 38.2883 43.9471 38.6201L44.1564 38.961C44.7147 38.6182 45.2438 38.2327 45.7393 37.8091L45.4794 37.505ZM42.2596 39.4816C41.6803 39.7218 41.0784 39.9182 40.4578 40.0667L40.5508 40.4557C41.1921 40.3022 41.8142 40.0993 42.4128 39.8511L42.2596 39.4816ZM38.5862 40.361C38.2732 40.3853 37.9569 40.3977 37.6377 40.3977V40.7977C37.9673 40.7977 38.2939 40.7849 38.6171 40.7598L38.5862 40.361ZM37.6377 40.1977C37.4167 40.1977 37.2377 40.3768 37.2377 40.5977C37.2377 40.8186 37.4167 40.9977 37.6377 40.9977V40.1977ZM37.0129 16.465C37.2335 16.4535 37.4031 16.2654 37.3917 16.0448C37.3802 15.8242 37.1921 15.6546 36.9715 15.666L37.0129 16.465ZM37.4155 15.6507C37.1947 15.6545 37.0187 15.8367 37.0225 16.0576C37.0263 16.2784 37.2084 16.4544 37.4293 16.4506L37.4155 15.6507ZM38.5707 16.4849C38.7909 16.502 38.9833 16.3374 39.0004 16.1171C39.0176 15.8969 38.8529 15.7044 38.6326 15.6873L38.5707 16.4849ZM40.5974 15.9964C40.3825 15.945 40.1667 16.0775 40.1153 16.2923C40.0639 16.5072 40.1964 16.723 40.4112 16.7744L40.5974 15.9964ZM42.1829 17.3497C42.387 17.4343 42.621 17.3375 42.7057 17.1334C42.7903 16.9294 42.6934 16.6954 42.4894 16.6107L42.1829 17.3497ZM44.2611 17.5151C44.0729 17.3995 43.8265 17.4584 43.7109 17.6467C43.5953 17.8349 43.6542 18.0813 43.8425 18.1969L44.2611 17.5151ZM45.3494 19.2935C45.5174 19.4371 45.7699 19.4173 45.9134 19.2494C46.057 19.0815 46.0372 18.829 45.8693 18.6854L45.3494 19.2935ZM47.2755 20.0916C47.1319 19.9237 46.8794 19.904 46.7115 20.0475C46.5436 20.1911 46.5239 20.4436 46.6674 20.6115L47.2755 20.0916ZM47.7641 22.1185C47.8797 22.3067 48.126 22.3656 48.3142 22.25C48.5025 22.1344 48.5614 21.8881 48.4458 21.6998L47.7641 22.1185ZM49.3502 23.4715C49.2656 23.2675 49.0316 23.1707 48.8275 23.2553C48.6234 23.3399 48.5266 23.5739 48.6112 23.778L49.3502 23.4715ZM49.1865 25.5497C49.2379 25.7645 49.4538 25.897 49.6686 25.8456C49.8835 25.7942 50.016 25.5784 49.9646 25.3636L49.1865 25.5497ZM50.2736 27.3283C50.2565 27.1081 50.0641 26.9434 49.8438 26.9605C49.6236 26.9776 49.4589 27.17 49.476 27.3903L50.2736 27.3283ZM49.476 29.2563C49.4589 29.4765 49.6236 29.669 49.8438 29.6861C50.0641 29.7032 50.2565 29.5385 50.2736 29.3183L49.476 29.2563ZM49.9646 31.283C50.016 31.0682 49.8835 30.8523 49.6686 30.8009C49.4538 30.7495 49.2379 30.882 49.1865 31.0969L49.9646 31.283ZM48.6112 32.8686C48.5266 33.0726 48.6234 33.3067 48.8275 33.3913C49.0316 33.4759 49.2656 33.3791 49.3502 33.175L48.6112 32.8686ZM48.4458 34.9467C48.5614 34.7585 48.5025 34.5122 48.3142 34.3965C48.126 34.2809 47.8797 34.3398 47.7641 34.5281L48.4458 34.9467ZM46.6674 36.0351C46.5239 36.203 46.5436 36.4555 46.7115 36.599C46.8794 36.7426 47.1319 36.7228 47.2755 36.5549L46.6674 36.0351ZM45.8693 37.9611C46.0372 37.8176 46.057 37.5651 45.9134 37.3971C45.7699 37.2292 45.5174 37.2095 45.3494 37.353L45.8693 37.9611ZM43.8425 38.4497C43.6542 38.5653 43.5953 38.8116 43.7109 38.9999C43.8265 39.1881 44.0729 39.247 44.2611 39.1314L43.8425 38.4497ZM42.4894 40.0358C42.6934 39.9512 42.7903 39.7172 42.7057 39.5131C42.621 39.309 42.387 39.2122 42.1829 39.2968L42.4894 40.0358ZM40.4112 39.8722C40.1964 39.9236 40.0639 40.1394 40.1153 40.3542C40.1667 40.5691 40.3825 40.7016 40.5974 40.6502L40.4112 39.8722ZM38.6326 40.9592C38.8529 40.9421 39.0176 40.7497 39.0004 40.5294C38.9833 40.3092 38.7909 40.1445 38.5707 40.1616L38.6326 40.9592ZM36.805 16.4776C36.8741 16.4728 36.9434 16.4686 37.0129 16.465L36.9715 15.666C36.8974 15.6699 36.8235 15.6744 36.7497 15.6795L36.805 16.4776ZM37.4293 16.4506C37.4986 16.4494 37.5681 16.4488 37.6377 16.4488V15.6488C37.5635 15.6488 37.4894 15.6495 37.4155 15.6507L37.4293 16.4506ZM37.6377 16.4488C37.9517 16.4488 38.2629 16.461 38.5707 16.4849L38.6326 15.6873C38.3042 15.6618 37.9724 15.6488 37.6377 15.6488V16.4488ZM40.4112 16.7744C41.0215 16.9204 41.6134 17.1135 42.1829 17.3497L42.4894 16.6107C41.8812 16.3585 41.249 16.1523 40.5974 15.9964L40.4112 16.7744ZM43.8425 18.1969C44.3738 18.5232 44.8776 18.8902 45.3494 19.2935L45.8693 18.6854C45.3659 18.2551 44.8283 17.8634 44.2611 17.5151L43.8425 18.1969ZM46.6674 20.6115C47.0708 21.0833 47.4378 21.5871 47.7641 22.1185L48.4458 21.6998C48.0975 21.1327 47.7059 20.5951 47.2755 20.0916L46.6674 20.6115ZM48.6112 23.778C48.8474 24.3476 49.0405 24.9395 49.1865 25.5497L49.9646 25.3636C49.8087 24.7119 49.6024 24.0798 49.3502 23.4715L48.6112 23.778ZM49.476 27.3903C49.4999 27.6981 49.5121 28.0092 49.5121 28.3233H50.3121C50.3121 27.9885 50.2991 27.6567 50.2736 27.3283L49.476 27.3903ZM49.5121 28.3233C49.5121 28.6374 49.4999 28.9485 49.476 29.2563L50.2736 29.3183C50.2991 28.9899 50.3121 28.6581 50.3121 28.3233H49.5121ZM49.1865 31.0969C49.0405 31.7071 48.8474 32.299 48.6112 32.8686L49.3502 33.175C49.6024 32.5668 49.8087 31.9347 49.9646 31.283L49.1865 31.0969ZM47.7641 34.5281C47.4378 35.0595 47.0708 35.5632 46.6674 36.0351L47.2755 36.5549C47.7059 36.0515 48.0975 35.5139 48.4458 34.9467L47.7641 34.5281ZM45.3494 37.353C44.8776 37.7564 44.3738 38.1234 43.8425 38.4497L44.2611 39.1314C44.8283 38.7831 45.3659 38.3915 45.8693 37.9611L45.3494 37.353ZM42.1829 39.2968C41.6134 39.533 41.0215 39.7262 40.4112 39.8722L40.5974 40.6502C41.249 40.4943 41.8812 40.288 42.4894 40.0358L42.1829 39.2968ZM38.5707 40.1616C38.2629 40.1855 37.9517 40.1977 37.6377 40.1977V40.9977C37.9724 40.9977 38.3042 40.9847 38.6326 40.9592L38.5707 40.1616Z",
    fill: "#66AFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5957C13 15.4911 13.8954 14.5957 15 14.5957H34.8221C35.9267 14.5957 36.8221 15.4911 36.8221 16.5957V50.3289H13V16.5957Z",
    fill: "#E6EFFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 17.5742,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 17.5742,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 20.8945,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 20.8945,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 24.2148,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 24.2148,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 24.2148,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 27.5352,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 30.8574,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 34.1777,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 37.498,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9414,
    y: 40.8203,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 27.5352,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 30.8574,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 34.1777,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8555,
    y: 37.498,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 17.5742,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 20.8945,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 24.2148,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 27.5352,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 30.8574,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 34.1777,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7734,
    y: 37.498,
    width: 4.92769,
    height: 2.32826,
    rx: 1,
    fill: "#C5D1E7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 41.0031,
    y: 19.552,
    width: 13.5732,
    height: 13.5732,
    rx: 6.78658,
    fill: "#E6F2FF",
    stroke: "#66AFFF",
    strokeWidth: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2115 22.8125H49.449C49.8105 22.8125 50.0525 23.1842 49.9063 23.5148L48.7914 26.0352H49.5982C50.0316 26.0352 50.2597 26.5488 49.9693 26.8704L47.5449 29.5544C47.2024 29.9336 46.5786 29.6153 46.6848 29.1153L46.9332 27.9455C46.9993 27.6345 46.7621 27.3416 46.4441 27.3416H45.9418C45.5955 27.3416 45.3541 26.9981 45.4714 26.6723L45.5817 26.3659C45.5854 26.3556 45.5894 26.3455 45.5938 26.3355L46.741 23.1434C46.8123 22.9449 47.0006 22.8125 47.2115 22.8125Z",
    fill: "#3395FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7203 39.9079C19.4759 38.0727 22.1695 34.6396 26.1647 32.4635C30.1599 30.2874 33.9153 30.3833 38.0758 32.4635C41.0177 33.9345 41.2537 36.6574 44.0313 38.419C47.2925 40.4874 51.5685 39.7718 53.4609 41.3968C55.3533 43.0218 56.0045 50.3301 52.4629 50.3301H18.7203C15.8687 50.3301 17.1706 43.6715 18.7203 39.9079Z",
    fill: "#CED9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9554 39.6632C44.9063 39.7267 43.62 39.7929 42.2383 39.8375C38.7336 39.9506 34.6868 39.9217 32.3114 39.388C31.1931 39.1368 30.5373 38.6307 30.1794 38.0606C29.8168 37.4831 29.722 36.7795 29.8422 36.0735C29.9629 35.3654 30.2956 34.6873 30.7405 34.1935C31.1883 33.6964 31.7081 33.4277 32.2018 33.4277H38.2742C38.586 33.4277 38.8957 33.5698 39.2503 33.8889C39.6106 34.2131 39.9667 34.6738 40.3712 35.2277C40.441 35.3232 40.512 35.4213 40.5844 35.5214C41.3236 36.5428 42.2119 37.7703 43.4476 38.5483C44.0943 38.9555 45.0584 39.3462 45.9554 39.6632Z",
    fill: "#37435A",
    stroke: "#ADBAD1",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5995,
    cy: 50.3299,
    r: 3.46665,
    fill: "#ADBAD1",
    stroke: "#37435A",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4432,
    cy: 50.3299,
    r: 3.46665,
    fill: "#ADBAD1",
    stroke: "#37435A",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4439,
    cy: 50.3286,
    r: 1.47513,
    fill: "#CED9ED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.604,
    cy: 50.3286,
    r: 1.47513,
    fill: "#CED9ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.219 41.6986C49.1831 40.4346 53.6921 40.3035 54.2693 42.9625C54.8466 45.6215 49.2548 42.9625 49.219 41.6986Z",
    fill: "#ADBAD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0861 42.003C51.0645 41.2414 53.7811 41.1625 54.1289 42.7645C54.4767 44.3665 51.1077 42.7645 51.0861 42.003Z",
    fill: "#E1AE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2G);
export default __webpack_public_path__ + "static/media/v2g.32eaf52e7cbf8e6baef3fe3be008719a.svg";
export { ForwardRef as ReactComponent };